import { Breakpoint } from "@omni/types/enums/breakPoint.enum";
import { description } from "@omni/ui/components/Product/ProductTile/components/description.style";
import { tv } from "tailwind-variants";

const base = tv({
    base: ["tw:bg-white tw:h-full tw:flex-col tw:relative"],
    variants: {
        breakpoint: {
            "none": "tw:flex",
            [Breakpoint.xs]: "tw:xs:flex",
            [Breakpoint.sm]: "tw:sm:flex",
            [Breakpoint.md]: "tw:md:flex",
            [Breakpoint.lg]: "tw:lg:flex",
            [Breakpoint.xl]: "tw:xl:flex"
        },
        link: {
            true: "tw:cursor-pointer",
            false: "tw:cursor-default"
        },
        hover: {
            true: "tw:transition-colors",
            false: ""
        },
        border: {
            true: "tw:border tw:border-tertiary tw:p-4 tw:rounded-xl",
            false: ""
        },
        padding: {
            true: "tw:p-4",
            false: ""
        }
    },
    compoundVariants: [
        {
            hover: true,
            border: true,
            className:
                "tw:hover:border tw:hover:border-primary tw:group-[*]/productTile-active:border tw:group-[*]/productTile-active:border-primary"
        }
    ],
    defaultVariants: {
        breakpoint: "none"
    }
});

export const ProductTileStyle = Object.assign(base, {
    description: description
});
